module.exports = __webpack_public_path__ + "logo.svg?973551be59b1817fec63f9ed78a2fba6";


//////////////////
// WEBPACK FOOTER
// ./static/logo.svg
// module id = 21
// module chunks = 0